import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClothingErrorCode, ClothingErrorResponse } from '../models/clothing.model';

const CLOTHING_ERROR_DEFAULT_KEY = 'CLOTHING_ERROR_DEFAULT';
const CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY = 'CLOTHING_CATALOG_ITEM_NOT_FOUND';
const CLOTHING_LOSS_CASE_NOT_FOUND_KEY = 'CLOTHING_LOSS_CASE_NOT_FOUND';
const CLOTHING_NORM_NOT_FOUND_KEY = 'CLOTHING_NORM_NOT_FOUND';
const CLOTHING_POSITION_NOT_FOUND_KEY = 'CLOTHING_POSITION_NOT_FOUND';
const CLOTHING_REQUEST_NOT_FOUND_KEY = 'CLOTHING_REQUEST_NOT_FOUND';
const CLOTHING_SETTINGS_NOT_CONFIGURED_KEY = 'CLOTHING_SETTINGS_NOT_CONFIGURED';
const CLOTHING_STOREKEEPER_NOT_FOUND_KEY = 'CLOTHING_STOREKEEPER_ASSIGNMENT_NOT_FOUND';
const CLOTHING_ACCESS_DENIED_KEY = 'CLOTHING_ACCESS_DENIED';
const CLOTHING_REQUEST_CONFLICT_KEY = 'CLOTHING_REQUEST_CONFLICT';
const CLOTHING_LOSS_DECISION_CONFLICT_KEY = 'CLOTHING_LOSS_DECISION_CONFLICT';
const CLOTHING_STOREKEEPER_CONFLICT_KEY = 'CLOTHING_STOREKEEPER_ASSIGNMENT_CONFLICT';
const CLOTHING_MARKER_NOT_CONFIGURED_KEY = 'CLOTHING_MARKER_NOT_CONFIGURED';
const CLOTHING_VALIDATION_ERROR_KEY = 'CLOTHING_VALIDATION_ERROR';
const CLOTHING_REQUEST_VALIDATION_FAILED_KEY = 'CLOTHING_REQUEST_VALIDATION_FAILED';
const CLOTHING_REQUEST_PARAMETER_MISSING_KEY = 'CLOTHING_REQUEST_PARAMETER_MISSING';
const CLOTHING_REQUEST_PARAMETER_INVALID_KEY = 'CLOTHING_REQUEST_PARAMETER_INVALID';
const CLOTHING_REQUEST_ALREADY_ACTIVE_KEY = 'CLOTHING_REQUEST_ALREADY_ACTIVE';
const CLOTHING_REQUEST_NOT_ALLOWED_BY_STATE_KEY = 'CLOTHING_REQUEST_NOT_ALLOWED_BY_STATE';
const CLOTHING_LOSS_ALREADY_OPEN_KEY = 'CLOTHING_LOSS_ALREADY_OPEN';

interface ClothingErrorTranslationKeyMap {
  [errorCode: number]: string;
}

const CLOTHING_ERROR_TRANSLATION_KEYS: ClothingErrorTranslationKeyMap = {};
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateCatalogItemNotFound] = CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateSettingsNotConfigured] = CLOTHING_SETTINGS_NOT_CONFIGURED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateMarkerNotConfigured] = CLOTHING_MARKER_NOT_CONFIGURED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateNormNotConfigured] = CLOTHING_NORM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateStorekeeperNotAssigned] = CLOTHING_STOREKEEPER_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateAlreadyActiveRequest] = CLOTHING_REQUEST_ALREADY_ACTIVE_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateNotAllowedByState] = CLOTHING_REQUEST_NOT_ALLOWED_BY_STATE_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateValidationFailed] = CLOTHING_REQUEST_VALIDATION_FAILED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeRequestCreateAccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeLossCaseCatalogItemNotFound] = CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeLossCasePositionNotFound] = CLOTHING_POSITION_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeLossCaseAlreadyOpen] = CLOTHING_LOSS_ALREADY_OPEN_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeLossCaseValidationFailed] = CLOTHING_VALIDATION_ERROR_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.EmployeeLossCaseAccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.HeadLossDecisionCaseNotFound] = CLOTHING_LOSS_CASE_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.HeadLossDecisionAlreadyDecided] = CLOTHING_LOSS_DECISION_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.HeadLossDecisionPositionNotFound] = CLOTHING_POSITION_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.HeadLossDecisionCatalogItemNotFound] = CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.HeadLossDecisionAccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.HeadLossDecisionValidationFailed] = CLOTHING_VALIDATION_ERROR_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CeoLossDecisionCaseNotFound] = CLOTHING_LOSS_CASE_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CeoLossDecisionAlreadyDecided] = CLOTHING_LOSS_DECISION_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CeoLossDecisionPositionNotFound] = CLOTHING_POSITION_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CeoLossDecisionCatalogItemNotFound] = CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CeoLossDecisionAccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CeoLossDecisionValidationFailed] = CLOTHING_VALIDATION_ERROR_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperRequestNotFound] = CLOTHING_REQUEST_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperRequestConflict] = CLOTHING_REQUEST_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperRequestValidationFailed] = CLOTHING_REQUEST_VALIDATION_FAILED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperAccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperSettingsNotConfigured] = CLOTHING_SETTINGS_NOT_CONFIGURED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminCatalogItemNotFound] = CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminNormNotFound] = CLOTHING_NORM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminSettingsNotConfigured] = CLOTHING_SETTINGS_NOT_CONFIGURED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminStorekeeperAssignmentNotFound] = CLOTHING_STOREKEEPER_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminConflict] = CLOTHING_REQUEST_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminValidationFailed] = CLOTHING_VALIDATION_ERROR_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AdminAccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.CatalogItemNotFound] = CLOTHING_CATALOG_ITEM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.LossCaseNotFound] = CLOTHING_LOSS_CASE_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.NormNotFound] = CLOTHING_NORM_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.PositionNotFound] = CLOTHING_POSITION_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.RequestNotFound] = CLOTHING_REQUEST_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.SettingsNotConfigured] = CLOTHING_SETTINGS_NOT_CONFIGURED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperAssignmentNotFound] = CLOTHING_STOREKEEPER_NOT_FOUND_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.AccessDenied] = CLOTHING_ACCESS_DENIED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.RequestConflict] = CLOTHING_REQUEST_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.LossDecisionConflict] = CLOTHING_LOSS_DECISION_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.StorekeeperAssignmentConflict] = CLOTHING_STOREKEEPER_CONFLICT_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.MarkerNotConfigured] = CLOTHING_MARKER_NOT_CONFIGURED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.ValidationError] = CLOTHING_VALIDATION_ERROR_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.RequestValidationFailed] = CLOTHING_REQUEST_VALIDATION_FAILED_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.RequestParameterMissing] = CLOTHING_REQUEST_PARAMETER_MISSING_KEY;
CLOTHING_ERROR_TRANSLATION_KEYS[ClothingErrorCode.RequestParameterInvalid] = CLOTHING_REQUEST_PARAMETER_INVALID_KEY;

@Injectable()
export class ClothingErrorService {
  constructor(private translate: TranslateService) {}

  resolveMessage(error: HttpErrorResponse, fallbackKey: string): string {
    var clothingError = this.parseClothingError(error);

    if (clothingError) {
      return this.resolveClothingMessage(clothingError, fallbackKey);
    }
    return this.resolveFallbackMessage(fallbackKey);
  }

  resolveDefaultMessage(error: HttpErrorResponse): string {
    return this.resolveMessage(error, CLOTHING_ERROR_DEFAULT_KEY);
  }

  parseClothingError(error: HttpErrorResponse): ClothingErrorResponse {
    if (!error || !error.error || typeof error.error !== 'object') {
      return null;
    }
    return this.parseBody(error.error as ClothingErrorResponse);
  }

  private parseBody(body: ClothingErrorResponse): ClothingErrorResponse {
    if (!body || typeof body.errorCode !== 'number') {
      return null;
    }
    return body;
  }

  private resolveClothingMessage(
    error: ClothingErrorResponse,
    fallbackKey: string
  ): string {
    var translationKey = this.resolveTranslationKey(error.errorCode);

    if (!translationKey.length) {
      return this.resolveFallbackMessage(fallbackKey);
    }
    return this.resolveKnownMessage(translationKey, fallbackKey);
  }

  private resolveTranslationKey(errorCode: ClothingErrorCode): string {
    var translationKey = CLOTHING_ERROR_TRANSLATION_KEYS[errorCode];

    if (!translationKey) {
      return '';
    }
    return translationKey;
  }

  private resolveKnownMessage(translationKey: string, fallbackKey: string): string {
    var translatedMessage = this.resolveTranslatedMessage(translationKey);

    if (translatedMessage.length) {
      return translatedMessage;
    }
    return this.resolveFallbackMessage(fallbackKey);
  }

  private resolveTranslatedMessage(key: string): string {
    var translatedMessage = this.translate.instant(key);

    if (!translatedMessage || translatedMessage === key) {
      return '';
    }
    return translatedMessage;
  }

  private resolveFallbackMessage(fallbackKey: string): string {
    var translatedMessage = this.resolveTranslatedMessage(fallbackKey);

    if (translatedMessage.length) {
      return translatedMessage;
    }
    return this.translate.instant(CLOTHING_ERROR_DEFAULT_KEY);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/clothing-error.service.ts